export default __webpack_public_path__ + "c4ab7bba5774eddfc265f1f339573917.png";